import { fetchProviderName, getCachedName, LazyProvider } from 'app/components/shared/LazyProvider'

function buildCacheKey(providerId?: string) {
  if (!providerId) return ``
  return `provider:${providerId}`
}

export async function getProviderName(providerId: string) {
  const cacheKey = buildCacheKey(providerId)
  if (!cacheKey) return ``
  const cached = getCachedName(cacheKey)
  if (cached != null) return cached
  return fetchProviderName(cacheKey, `/api/providers/name?ids=${encodeURIComponent(providerId)}`)
}

export function LazyProviderById(props: {
  providerId?: string
  showIcon?: boolean
  showSpinner?: boolean
  hideWith?: boolean
}) {
  const cacheKey = buildCacheKey(props.providerId)

  return (
    <LazyProvider
      cacheKey={cacheKey}
      fetchName={() => getProviderName(props.providerId!)}
      showIcon={props.showIcon}
      showSpinner={props.showSpinner}
      hideWith={props.hideWith}
    />
  )
}
